import { useState } from 'react';
import BookingModal from '../../../components/BookingModal';

export default function Fleet() {
  const [selectedBoat, setSelectedBoat] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const boats = [
    {
      name: 'My Way\'s Time',
      image: 'https://www.rentadeyatesylanchasveracruz.com/assets/img/rentadelachasyyatesveracruz1.jpg',
      capacity: '9 pasajeros',
      passengers: 9,
      price: 16000,
      priceDetail: 'x 5 hrs',
      features: ['Sombra', 'Baño', 'Chalecos salvavidas', 'Flotadores', 'Snorkel', 'Música', 'Capitán'],
      description: 'Embarcación Boston Whaler 22\'. Tour de 5 horas: Cañonero Tampico, Foro Boca, Bahía Boca del Río - Veracruz, Isla verde (dónde podrás hacer Snorkeling), Cancuncito, Isla de sacrificios y Retorno a la Marina.'
    },
    {
      name: 'Lucrecia\'s Party',
      image: 'https://www.rentadeyatesylanchasveracruz.com/assets/img/rentadelachasyyatesveracruz2.jpg',
      capacity: '10 pasajeros',
      passengers: 10,
      price: 19000,
      priceDetail: 'x 5 hrs',
      features: ['Mesa central', 'Hielera', 'Sombra', 'Regadera', 'Baño', 'Chalecos', 'Flotadores', 'Snorkel', 'Música', 'Capitán'],
      description: 'Embarcación Edgewater 27\'. Tour de 5 horas: Cañonero Tampico, Foro Boca, Bahía Boca del Río - Veracruz, Isla verde (dónde podrás hacer Snorkeling), Cancuncito, Isla de sacrificios y Retorno a la Marina.'
    },
    {
      name: 'Partner\'s Time',
      image: 'https://www.rentadeyatesylanchasveracruz.com/assets/img/rentadelachasyyatesveracruz3.jpg',
      capacity: '13 pasajeros',
      passengers: 13,
      price: 27000,
      priceDetail: 'x 5 hrs',
      features: ['Mesa central', 'Hielera', 'Sombra', 'Baño', 'Chalecos', 'Flotadores', 'Snorkel', 'Música', 'Capitán'],
      description: 'Embarcación Rinker 29\'. Tour de 5 horas: Cañonero Tampico, Foro Boca, Bahía Boca del Río - Veracruz, Isla verde (dónde podrás hacer Snorkeling), Cancuncito, Isla de sacrificios y Retorno a la Marina.'
    },
    {
      name: 'Cayoya',
      image: 'https://www.rentadeyatesylanchasveracruz.com/assets/img/seapro.jpg',
      capacity: '11 pasajeros',
      passengers: 11,
      price: 23000,
      priceDetail: 'x 5 hrs',
      features: ['Hielera', 'Sombra', 'Chalecos', 'Flotadores', 'Música', 'Capitán'],
      description: 'Embarcación Sea Pro 18\'. Tour de 5 horas: Río el estero, Buque Cañonero Tampico, Foro Boka, Boca del Río, Paseo por la Bahía Cancuncito, Isla Verde, Isla de Sacrificios, Zona de Snorkel, Retorno a la Marina.'
    },
    {
      name: 'Negrita\'s Time',
      image: 'https://www.rentadeyatesylanchasveracruz.com/assets/img/yatecruiser.jpg',
      capacity: '12 pasajeros',
      passengers: 12,
      price: 33000,
      priceDetail: 'x 5 hrs',
      features: ['Mesa central', 'Dos hieleras', 'Sombra', 'Regadera', 'Baño', 'Chalecos', 'Flotadores', 'Snorkel', 'Música', 'Capitán'],
      description: 'Embarcación Yate Crusier 30\'. Tour de 5 horas: Río el estero, Buque Cañonero Tampico, Foro Boka, Boca del Río, Paseo por la Bahía Cancuncito, Isla de Sacrificios, Zona de Snorkel, Retorno a la Marina.'
    },
    {
      name: 'Flipper',
      image: 'https://www.rentadeyatesylanchasveracruz.com/assets/img/yatebonton.jpg',
      capacity: '14 pasajeros',
      passengers: 14,
      price: 30000,
      priceDetail: 'x 5 hrs',
      features: ['Mesa central', 'Dos hieleras', 'Sombra', 'Regadera', 'Baño', 'Chalecos', 'Flotadores', 'Snorkel', 'Música', 'Capitán'],
      description: 'Embarcación Flipper. Tour de 5 horas: Río el Estero, Buque Cañonero Tampico, Foro Boka, Boca del Río, Paseo por la Bahía Peyote Polito, Isla Salmedina, Isla de Enmedio, Retorno a la Marina.'
    },
    {
      name: 'Tachi Boat',
      image: 'https://www.rentadeyatesylanchasveracruz.com/assets/img/edgewater.jpg',
      capacity: '6 pasajeros',
      passengers: 6,
      price: 15000,
      priceDetail: 'x 5 hrs',
      features: ['Hielera', 'Sombra', 'Chalecos', 'Flotadores', 'Música', 'Capitán'],
      description: 'Embarcación Edgewater 18\'6. Tour de 5 horas: Río el Estero, Buque Cañonero Tampico, Foro Boka, Boca del Río, Paseo por la Bahía Cancuncito, Isla Verde, Isla de Sacrificio, Zona de Snorkel, Retorno a la Marina.'
    },
    {
      name: 'Paulina',
      image: 'https://www.rentadeyatesylanchasveracruz.com/assets/img/wellcraft.jpg',
      capacity: '10 pasajeros',
      passengers: 10,
      price: 28000,
      priceDetail: 'x 5 hrs',
      features: ['Mesa central', 'Dos hieleras', 'Sombra', 'Regadera', 'Baño', 'Chalecos', 'Flotadores', 'Snorkel', 'Música', 'Capitán'],
      description: 'Embarcación Wellcraft 30\'. Tour de 5 horas: Río el Estero, Buque Cañonero Tampico, Foro Boka, Boca del Río, Paseo por la Bahía Peyote Polito, Isla Salmedina, Isla de Enmedio, Retorno a la Marina.'
    },
    {
      name: 'Yate Whisky',
      image: 'https://www.rentadeyatesylanchasveracruz.com/assets/img/yatechriscraft.jpg',
      capacity: '20 pasajeros',
      passengers: 20,
      price: 37000,
      priceDetail: 'x 5 hrs',
      features: ['Mesa central', 'Dos hieleras', 'Sombra', 'Regadera', 'Baño', 'Chalecos', 'Flotadores', 'Snorkel', 'Música', 'Capitán'],
      description: 'Embarcación Yate Chris Craft 50\'. Tour de 5 horas: Río el Estero, Buque Cañonero Tampico, Foro Boka, Boca del Río, Paseo por la Bahía Peyote Polito, Isla Salmedina, Isla de Enmedio, Retorno a la Marina.'
    }
  ];

  const handleReservation = (boat: any) => {
    setSelectedBoat(boat);
    setIsModalOpen(true);
  };

  return (
    <>
      <section id="fleet" className="py-24 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Nuestra Flota
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Embarcaciones modernas y bien mantenidas para garantizar tu seguridad y comodidad
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {boats.map((boat, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
                data-product-shop
              >
                <div className="relative w-full h-64 overflow-hidden">
                  <img
                    src={boat.image}
                    alt={boat.name}
                    className="w-full h-full object-cover object-top"
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.onerror = null;
                      target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAwIiBoZWlnaHQ9IjYwMCIgdmlld0JveD0iMCAwIDgwMCA2MDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI4MDAiIGhlaWdodD0iNjAwIiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik00MDAgMzAwTDQ1MCAzNTBIMzUwTDQwMCAzMDBaIiBmaWxsPSIjRDRERDE5Ii8+CjxwYXRoIGQ9Ik00MDAgMjUwTDQyNSAyNzVIMzc1TDQwMCAyNTBaIiBmaWxsPSIjRDRERDE5Ii8+CjxwYXRoIGQ9Ik0yMDAgNDAwSDYwMFY0NTBIMjAwVjQwMFoiIGZpbGw9IiM5Q0EzQUYiLz4KPHN2Zz4K';
                    }}
                  />
                  <div className="absolute top-4 right-4 bg-teal-500 text-white px-4 py-2 rounded-full font-bold text-sm">
                    ${boat.price.toLocaleString('es-MX')} {boat.priceDetail}
                  </div>
                </div>
                
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">
                    {boat.name}
                  </h3>
                  <div className="flex items-center text-gray-600 mb-4">
                    <i className="ri-group-line mr-2"></i>
                    <span>Capacidad: {boat.capacity}</span>
                  </div>
                  
                  <p className="text-gray-600 mb-4 leading-relaxed text-sm">
                    {boat.description}
                  </p>

                  <div className="space-y-2 mb-6">
                    {boat.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center text-sm text-gray-700">
                        <i className="ri-check-line text-teal-500 mr-2"></i>
                        <span>{feature}</span>
                      </div>
                    ))}
                  </div>

                  <button 
                    onClick={() => handleReservation(boat)}
                    className="w-full py-3 bg-teal-500 hover:bg-teal-600 text-white font-semibold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
                  >
                    Reservar Ahora
                  </button>
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-12">
            <p className="text-lg font-semibold text-gray-800">
              ***Realiza tu Reservación con el 25% y el 75% Restante al embarcar***
            </p>
          </div>
        </div>
      </section>

      {selectedBoat && (
        <BookingModal
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
            setSelectedBoat(null);
          }}
          boat={selectedBoat}
        />
      )}
    </>
  );
}
